// extracted by mini-css-extract-plugin
export default {"markdown":"UserGuide_markdown__2CdGb"};